exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.register-form {\n  border: 2px solid var(--main);\n  border-radius: 10px;\n  padding: 30px 30px;\n}\n.form-control {\n  height: 40px !important;\n}\n.box-info {\n  background: #eee;\n  padding: 10px 20px;\n}\noption:disabled {\n  background: rgb(170, 170, 170);\n}\n.mx-datepicker {\n  display: block;\n  width: 100%;\n}\n@media (max-width: 767px) {\n.app-name {\n    font-size: 1.7rem;\n}\n}\n", ""]);

// exports
